<div class="top-bar row" [ngClass]="{ topbarScrolled: scrolled }">  
        <button type="button" (click)="openMenu()" [hidden]="isOpen" class="menu" >
        </button>
        <button type="button" class="command-button createRouletteButton"
      (click)="createRoulette()">{{'ROULETTE.CREATE_ROULETTE' | translate}}</button>
    <span class="logo"></span>
</div>
<button class="main-menu full-height full-width row" (click)="closeMenu()" [hidden]="!isOpen">
    <div class="content-menu full-height">
        <div class="top-bar open  row">
           
            <button>
                <img src="assets/images/icons/close-menu.svg" />
            </button>
            <span class="logo"></span>
        </div>
        <div class="column">
            <a href="/webplatform/profile">{{'MENU.PROFILE' | translate}}</a>
            <a href="#solutions">{{'TOP_BAR_MENU.SOLUTIONS' | translate}}</a>
            <a href="#howItWork">{{'TOP_BAR_MENU.HOW_IT_WORKS' | translate}}</a>
            <a href="#customers-tell">{{'TOP_BAR_MENU.CUSTOMERS' | translate}}</a>
            <a href="#prices">{{'TOP_BAR_MENU.PRICES' | translate}}</a>
            <a href="#commonQuestions">{{'TOP_BAR_MENU.COMMON_QUESTIONS' | translate}}</a>
        </div>
    </div>
</button>